/* ==========================================================================
   product.js — gallery thumbnails, zoom, and optional product video for
   the product page. Clicking a thumb swaps the main stage image via its
   data-full-src attribute (real Shopify product photos). Falls back to the
   placeholder emoji wiggle when a product has no real images yet.
   ========================================================================== */
(function () {
  "use strict";

  var gallery = document.querySelector("[data-gallery]");
  if (!gallery) return;

  var mainMedia = gallery.querySelector("[data-gallery-main]");
  var mainEmoji = mainMedia ? mainMedia.querySelector(".media-emoji") : null;
  var mainImg = mainMedia ? mainMedia.querySelector("[data-gallery-main-img]") : null;
  var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
  var videoPane = gallery.querySelector("[data-gallery-video]");
  var videoThumb = gallery.querySelector("[data-gallery-video-thumb]");
  var videoEmbed = videoPane ? videoPane.querySelector("[data-gallery-video-embed]") : null;

  function clearActiveThumbs() {
    thumbs.forEach(function (t) { t.classList.remove("is-active"); });
    if (videoThumb) videoThumb.classList.remove("is-active");
  }

  function stopVideo() {
    if (!videoEmbed) return;
    if (videoEmbed.tagName === "IFRAME") {
      videoEmbed.src = ""; // drop the embed src so playback actually stops
    } else if (videoEmbed.tagName === "VIDEO") {
      videoEmbed.pause();
    }
  }

  function showImage() {
    if (videoPane) {
      videoPane.hidden = true;
      stopVideo();
    }
    if (mainMedia) mainMedia.hidden = false;
  }

  function showVideo() {
    if (!videoPane || !videoEmbed) return;
    if (mainMedia) mainMedia.hidden = true;
    videoPane.hidden = false;
    // Lazy-load: only point the iframe at the real embed URL once the
    // visitor actually asks to watch it, so an unplayed product page never
    // makes a request to YouTube/Vimeo.
    if (videoEmbed.tagName === "IFRAME" && !videoEmbed.src) {
      videoEmbed.src = videoEmbed.getAttribute("data-src");
    }
  }

  // Crossfade to a new photo: preload it, fade the current one out, swap, fade back in.
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var swapToken = 0;
  function swapMainImage(src, alt) {
    if (!mainImg) return;
    if (reduceMotion || mainImg.getAttribute("src") === src) {
      mainImg.src = src;
      if (alt) mainImg.alt = alt;
      return;
    }
    var token = ++swapToken;
    var pre = new Image();
    var done = function () {
      if (token !== swapToken) return; // a newer image was requested meanwhile
      mainImg.classList.add("is-fading");
      window.setTimeout(function () {
        if (token !== swapToken) return;
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        mainImg.classList.remove("is-fading");
      }, 300);
    };
    pre.onload = done;
    pre.onerror = done;
    pre.src = src;
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      clearActiveThumbs();
      thumb.classList.add("is-active");
      showImage();
      var fullSrc = thumb.getAttribute("data-full-src");
      if (mainImg && fullSrc) {
        // Real product photo: swap the main stage image to match the clicked thumb.
        swapMainImage(fullSrc, thumb.getAttribute("data-alt") || mainImg.alt);
      } else if (mainEmoji) {
        // No real photos yet: fall back to the placeholder wiggle animation.
        mainEmoji.style.transform = "rotate(" + (Math.random() * 10 - 5) + "deg)";
      }
    });
  });

  if (videoThumb) {
    videoThumb.addEventListener("click", function () {
      clearActiveThumbs();
      videoThumb.classList.add("is-active");
      showVideo();
    });
  }

  if (mainMedia) {
    mainMedia.addEventListener("click", function () {
      mainMedia.classList.toggle("is-zoomed");
      if (mainEmoji) {
        mainEmoji.style.transform = mainMedia.classList.contains("is-zoomed") ? "scale(1.55)" : "scale(1)";
      }
    });
  }
})();

/* ==========================================================================
   Variant picker (colour / size ...) — picks the matching Shopify variant,
   then updates the price, the stock note, the Add to Cart / Buy Now buttons
   and the main photo. Reads the list of variants from
   <script data-product-variants> written by sections/main-product.liquid.
   ========================================================================== */
(function () {
  "use strict";

  var dataEl = document.querySelector("[data-product-variants]");
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants.length) return;

  var optionsEl = document.querySelector("[data-product-options]");
  var groups = optionsEl ? Array.prototype.slice.call(optionsEl.querySelectorAll("[data-option-index]")) : [];
  var priceBlock = document.querySelector("[data-price-block]");
  var stockNote = document.querySelector("[data-stock-note]");
  var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-add-to-cart], [data-buy-now]"));
  var buyBtn = document.querySelector("[data-buy-now]");
  var addBtn = document.querySelector("[data-add-to-cart]");

  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function selection() {
    return groups.map(function (g) {
      var checked = g.querySelector("input:checked");
      return checked ? checked.value : null;
    });
  }

  function findVariant(sel) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) if (variants[i].options[j] !== sel[j]) { ok = false; break; }
      if (ok) return variants[i];
    }
    return null;
  }

  // Grey out values that would lead to a sold-out or non-existent combination.
  function markAvailability(sel) {
    groups.forEach(function (g, gi) {
      g.querySelectorAll("label.option-pill").forEach(function (label) {
        var value = label.querySelector("input").value;
        var test = sel.slice(); test[gi] = value;
        var v = findVariant(test);
        label.classList.toggle("is-unavailable", !v || !v.available);
      });
    });
  }

  function update(changedByUser) {
    var sel = selection();
    var v = groups.length ? findVariant(sel) : variants[0];
    groups.forEach(function (g, gi) {
      var label = g.querySelector("[data-option-selected]");
      if (label) label.textContent = sel[gi] || "";
    });
    markAvailability(sel);
    if (!v) { // combination that doesn't exist: disable buying until the visitor picks another
      buttons.forEach(function (b) { b.disabled = true; b.removeAttribute("data-variant-id"); });
      if (stockNote) { stockNote.textContent = "This combination is not available"; stockNote.style.color = "var(--ink-400)"; }
      return;
    }

    buttons.forEach(function (b) {
      b.setAttribute("data-variant-id", v.id);
      b.disabled = !v.available;
    });
    if (addBtn && !addBtn.getAttribute("data-label")) addBtn.setAttribute("data-label", addBtn.innerHTML);
    if (addBtn) addBtn.innerHTML = v.available ? addBtn.getAttribute("data-label") : "Sold Out";

    if (priceBlock) {
      var html = '<span class="price">' + money(v.price) + "</span>";
      if (v.compare_at_price > v.price) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<span class="price-compare">' + money(v.compare_at_price) + '</span><span class="price-save">Save ' + pct + "%</span>";
      }
      priceBlock.innerHTML = html;
    }
    if (stockNote) {
      stockNote.textContent = v.available ? "In Stock, Ready to Ship" : "Currently Out of Stock";
      stockNote.style.color = v.available ? "" : "var(--ink-400)";
    }

    // Show the photo that belongs to this variant (only when the visitor picked it).
    if (changedByUser && v.image) {
      var thumb = document.querySelector('[data-gallery-thumb][data-full-src="' + v.image + '"]');
      if (thumb) thumb.click();
    }

    // Keep the address in sync so a shared link opens the same variant.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState(null, "", url.toString());
    } catch (e) {}
  }

  if (optionsEl) {
    optionsEl.addEventListener("change", function () { update(true); });
    // ?variant=ID in the address selects that variant on load
    var wanted = new URLSearchParams(window.location.search).get("variant");
    if (wanted) {
      var target = variants.filter(function (x) { return String(x.id) === wanted; })[0];
      if (target) {
        groups.forEach(function (g, gi) {
          g.querySelectorAll("input").forEach(function (inp) { inp.checked = inp.value === target.options[gi]; });
        });
      }
    }
  }
  update(false);
})();


/* ==========================================================================
   Automatic image carousel — moves to the next photo every 9 seconds and
   loops back to the first one. A manual click/swipe restarts the 9-second
   countdown. It pauses while the tab is hidden, while the photo is zoomed,
   while the video is showing or while the gallery is off-screen, and does
   nothing for a product with a single photo.
   ========================================================================== */
(function () {
  "use strict";

  var INTERVAL = 9000;
  var gallery = document.querySelector("[data-gallery]");
  if (!gallery) return;

  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"))
    .filter(function (t) { return t.getAttribute("data-full-src"); });
  if (thumbs.length < 2) return;

  var stage = gallery.querySelector("[data-gallery-main]");
  var strip = gallery.querySelector(".gallery__thumbs");
  var videoPane = gallery.querySelector("[data-gallery-video]");
  var timer = null;
  var inView = true;
  var current = 0;

  function activeIndex() {
    for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains("is-active")) return i;
    return current;
  }

  function keepThumbVisible(thumb) {
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    var t = thumb.getBoundingClientRect();
    var c = strip.getBoundingClientRect();
    var target = strip.scrollLeft + (t.left - c.left) - (c.width - t.width) / 2;
    if (strip.scrollTo) strip.scrollTo({ left: target, behavior: "smooth" });
    else strip.scrollLeft = target;
  }

  function canAdvance() {
    if (document.hidden || !inView) return false;
    if (stage && (stage.classList.contains("is-zoomed") || stage.hidden)) return false;
    if (videoPane && !videoPane.hidden) return false;
    return true;
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(tick, INTERVAL);
  }

  function go(index) {
    current = (index + thumbs.length) % thumbs.length;
    thumbs[current].click(); // reuses the normal thumbnail behaviour (active state + photo swap)
  }

  function tick() {
    if (canAdvance()) go(activeIndex() + 1);
    else schedule();
  }

  // Any thumbnail click (visitor, variant picker or the carousel itself) restarts the countdown.
  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener("click", function () {
      current = i;
      keepThumbVisible(thumb);
      schedule();
    });
  });

  // Swipe left / right on the big photo (phones and tablets).
  if (stage) {
    var startX = 0, startY = 0, swiped = false;
    stage.addEventListener("touchstart", function (e) {
      var t = e.changedTouches[0];
      startX = t.clientX; startY = t.clientY; swiped = false;
    }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        swiped = true;
        go(activeIndex() + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
    // A swipe must not also toggle the zoom.
    stage.addEventListener("click", function (e) {
      if (swiped) { e.stopImmediatePropagation(); swiped = false; }
    }, true);
  }

  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
    }, { threshold: 0.2 }).observe(gallery);
  }
  document.addEventListener("visibilitychange", function () { if (!document.hidden) schedule(); });

  schedule();
})();

/* ==========================================================================
   Zodiac design picker — clicking a tile selects that sign (single choice),
   and writes it into the hidden properties[Zodiac Design] input so cart.js
   picks it up as a line item property when Add to Cart / Buy Now is pressed.
   ========================================================================== */
(function () {
  "use strict";

  var picker = document.querySelector("[data-zodiac-picker]");
  if (!picker) return;
  var tiles = Array.prototype.slice.call(picker.querySelectorAll("[data-zodiac-tile]"));
  var valueInput = picker.querySelector("[data-zodiac-value]");
  if (!tiles.length || !valueInput) return;

  tiles.forEach(function (tile) {
    tile.addEventListener("click", function () {
      tiles.forEach(function (t) { t.setAttribute("aria-checked", "false"); t.classList.remove("is-selected"); });
      tile.setAttribute("aria-checked", "true");
      tile.classList.add("is-selected");
      valueInput.value = tile.getAttribute("data-sign") || "";
    });
  });
})();

/* ==========================================================================
   Product information tabs (accessibility: aria state + arrow keys) and the
   "Leave a Review" notice. The visual switching itself lives in main.js.
   ========================================================================== */
(function () {
  "use strict";

  var tabs = document.querySelector(".pdp-tabs");
  if (tabs) {
    var btns = Array.prototype.slice.call(tabs.querySelectorAll(".tabs__btn"));
    var sync = function () {
      btns.forEach(function (b) {
        var on = b.classList.contains("is-active");
        b.setAttribute("aria-selected", on ? "true" : "false");
        b.tabIndex = on ? 0 : -1;
      });
    };
    btns.forEach(function (b) { b.addEventListener("click", function () { window.setTimeout(sync, 0); }); });
    tabs.querySelector(".tabs__nav").addEventListener("keydown", function (e) {
      var i = btns.indexOf(document.activeElement);
      if (i < 0) return;
      var next = null;
      if (e.key === "ArrowRight") next = btns[(i + 1) % btns.length];
      else if (e.key === "ArrowLeft") next = btns[(i - 1 + btns.length) % btns.length];
      else if (e.key === "Home") next = btns[0];
      else if (e.key === "End") next = btns[btns.length - 1];
      if (next) { e.preventDefault(); next.focus(); next.click(); }
    });
  }

  var openBtn = document.querySelector("[data-review-open]");
  var gate = document.getElementById("review-gate");
  if (openBtn && gate) {
    openBtn.addEventListener("click", function () {
      gate.hidden = false;
      openBtn.setAttribute("aria-expanded", "true");
    });
  }

  // Reviews list: only the first 6 show by default, "See all N reviews"
  // reveals the rest without reloading the page.
  var reviewsMoreBtn = document.querySelector("[data-reviews-more]");
  if (reviewsMoreBtn) {
    reviewsMoreBtn.addEventListener("click", function () {
      document.querySelectorAll("[data-review-extra]").forEach(function (li) {
        li.hidden = false;
      });
      reviewsMoreBtn.remove();
    });
  }
})();
